// modules/clover-android-services/src/CloverAndroidServicesModule.web.ts
export default {
  PI: Math.PI,
  async setValueAsync(value: string) { },
  hello() { return 'Hello world! 👋'; },
  
  // Mocks para evitar errores de "undefined" en las funciones que exporta tu index.ts
  initializePaymentConnector: () => "",
  initializeMifareCardReaderConnection: async () => "",
  cancelMifareCardReaderConnection: async () => true,
  refundPayment: () => {},
  performSale: () => {},
  performSaleToSitefApp: async () => ({}),
  printReceiptAfterSale: async () => true,
  printContinousReceiptAfterSale: async () => true,
  printReceiptForSitefSalesApp: async () => true,
  printCashBoxTicket: async () => ({}),
  checkIfPrinterHasPaperLoaded: async () => true,
  disposeCloverConnection: () => "",
};